import React, { useEffect, useState } from "react";
import "./Hero.css";
import fondo from "../assets/fd.jpg";
import { motion } from "framer-motion";

// imágenes del carrusel
import work1 from "../assets/works/Pmusa.jpg";
import work2 from "../assets/works/Reis.jpg";
import work3 from "../assets/works/Serio.jpg";
import loyal1 from "../assets/covers/sha/loyal/1.jpg";
import ofi1 from "../assets/covers/sha/ofi/5.jpg";

const images = [work1, work2, work3, loyal1, ofi1];

export default function Hero() {
  const [index, setIndex] = useState(0);

  // autoplay
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section
      className="hero"
      id="home"
      style={{ backgroundImage: `url(${fondo})` }}
    >
      <div className="hero-wrapper">
        <motion.div
          className="hero-left"
          initial={{ opacity: 0, x: -80 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <motion.h1
            className="hero-title"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
          >
            Sharp Design
          </motion.h1>

          <motion.p
            className="hero-subtitle"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.8 }}
          >
            Artista Grafico
          </motion.p>

          <motion.a
            href="#gallery"
            className="hero-btn"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.8 }}
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.95 }}
          >
            Mi Arte
          </motion.a>
        </motion.div>

        {/* RIGHT SIDE - CAROUSEL */}
        <div className="hero-right">
          <div className="carousel">
            {images.map((img, i) => (
              <img
                key={i}
                src={img}
                alt="work"
                className={i === index ? "carousel-img active" : "carousel-img"}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
